import {emotionStyled} from '@packages/utilities/styled';
import {Tag} from '@packages/systems/spring';
import {brandedFontFamily} from '../../constants';

const BRANDED_TAG_AS_LINK_HEIGHT = '$10';

export const BrandedTag = emotionStyled(Tag)(
  {
    borderRadius: '$2',
    "[data-text='true']": {
      fontFamily: brandedFontFamily,
      lineHeight: '16px',
      color: '$textPrimary',
    },
    a: {
      padding: '$0 $4',
      borderRadius: '$2',
      height: BRANDED_TAG_AS_LINK_HEIGHT,
    },
    '[data-sc="Tag"]': {
      borderRadius: '$2',
    },
  },
  {
    variants: {
      isOverflow: {
        true: {
          cursor: 'pointer',
        },
      },
      focused: {
        true: {
          border: `1.5px solid $blueBorder`,
        },
      },
    },
  }
);

BrandedTag.displayName = 'BrandedTag';

export default BrandedTag;
